import { render, staticRenderFns } from "./CommunicationsFormHelpDialog.vue?vue&type=template&id=6d332887&scoped=true"
import script from "./CommunicationsFormHelpDialog.vue?vue&type=script&lang=ts"
export * from "./CommunicationsFormHelpDialog.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationsFormHelpDialog.vue?vue&type=style&index=0&id=6d332887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d332887",
  null
  
)

export default component.exports